import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import "../whlpage/py6uicss.css";;

const Py6UIDownload = () => {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const wheelUrl = "https://albiemer.singlobby.com/albiemer/dist/py6ui-0.1.0-py3-none-any.whl";

    return (
        <>
            <Helmet>
                <title>py6ui | PySide6 Dynamic UI Loader</title>
                <meta 
                    name="description" 
                    content="Download py6ui - Lightweight PySide6 UI Loader. Install via .whl file and dynamically load Qt Designer .ui files with automatic widget binding." 
                />
            </Helmet>

            <div className="py6ui-container">

                {/* Banner */}
                <div 
                    className="py6ui-banner"
                    onClick={() => window.open("https://www.singlobby.com", "_blank")}
                >
                    <img 
                        src="https://res.cloudinary.com/dywqyzge2/image/upload/v1772299116/singlobby_banner_sokjnf.png" 
                        alt="Singlobby Promotion"
                    />
                </div>

                <div className="py6ui-card">

                    <h1 className="py6ui-title">
                        🚀 py6ui
                    </h1>

                    <p className="py6ui-subtitle">
                        Lightweight Dynamic UI Loader for PySide6
                    </p>

                    <section>
                        <h2>📦 Installation</h2>

                        <h3>Install via Direct URL</h3>
                        <pre className="code-block">
                            {`pip install ${wheelUrl}`}
                        </pre>

                        <h3>Or Download Wheel File</h3>
                        <a 
                            href={wheelUrl} 
                            download
                            className="download-btn"
                        >
                            Download py6ui .whl
                        </a>

                        <pre className="code-block">
                            {`pip install py6ui-0.1.0-py3-none-any.whl`}
                        </pre>
                    </section>

                    <section>
                        <h2>💡 Basic Usage</h2>

                        <pre className="code-block">
                            {`
                            from py6ui import LoadUi

                            ui = LoadUi("main.ui").load_ui()
                            ui.show()`}
                        </pre>
                    </section>

                    <section>
                        <h2>📺 Full Tutorial</h2>

                        <div className="tutorial-image-wrapper">
                            <img
                                src="https://res.cloudinary.com/dywqyzge2/image/upload/v1772385496/ChatGPT_Image_Mar_2_2026_01_13_40_AM_ow6k3y.png"
                                alt="py6ui Tutorial"
                            />
                        </div>
                    </section>

                </div>
            </div>
        </>
    );
};

export default Py6UIDownload;